import en from './en' //英文
import zh from './zh' //中文简体
import es from './es' //西语
import ja from './ja' //日语

export default {
  en,
  zh,
  es,
  ja
}
